import React from "react";
import { AWS_URL } from "../../../services/http.service";

const UserImage = ({ avatar }) => {
  // console.log("AWS_URL: ", AWS_URL);
  // console.log("avatar", avatar);
  return (
    <div
      className='h-10 w-10 rounded-full bg-sky-500 bg-cover bg-no-repeat bg-center'
      style={{
        backgroundImage: avatar
          ? "url(" + AWS_URL + avatar + ")"
          : 'url("https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png")',
      }}
    >
      <span className='sr-only'></span>
    </div>
  );
};

export default UserImage;
